/**
 * Main entry point for the application
 * Handles initialization, routing and service worker registration
 */

import { isMobileDevice } from './utils.js';

/**
 * Registers the service worker for offline capability
 */
async function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('./sw.js');
      console.log('[App] ServiceWorker registered:', registration.scope);
    } catch (error) {
      console.error('[App] ServiceWorker registration failed:', error);
    }
  }
}

/**
 * Handles device-based routing
 * Redirects users to the appropriate version based on device type
 */
function handleDeviceRouting() {
  const currentPath = window.location.pathname;
  const isMobile = isMobileDevice();

  // Only redirect on index page
  if (currentPath.endsWith('index.html') || currentPath.endsWith('/')) {
    if (isMobile) {
      // Redirect mobile users to mobile login
      window.location.href = './mobile.html';
      return true;
    }
  }

  // Prevent mobile users from accessing desktop version directly
  if (isMobile && currentPath.includes('desktop.html') && !currentPath.includes('mobile')) {
    window.location.href = './mobile-desktop.html';
    return true;
  }

  // Prevent desktop users from accessing mobile version directly
  if (!isMobile && currentPath.includes('mobile')) {
    if (currentPath.includes('mobile-desktop')) {
      window.location.href = './desktop.html';
    } else {
      window.location.href = './index.html';
    }
    return true;
  }

  return false;
}

/**
 * Initializes the application
 */
async function init() {
  // Service Worker disabled - not needed for this project
  // await registerServiceWorker();

  // Handle device-based routing
  if (handleDeviceRouting()) {
    return; // Redirecting, don't continue initialization
  }

  // Debug: Check if CSS is loaded
  const bgCheck = window.getComputedStyle(document.body).backgroundColor;
  console.log('[Debug] Body Background Color:', bgCheck);

  if (bgCheck === 'rgba(0, 0, 0, 0)' || bgCheck === 'transparent') {
    console.warn('[Debug] ⚠️ Warning: CSS might not be loaded correctly!');
  } else {
    console.log('[Debug] ✅ CSS seems to be loaded.');
  }

  console.log('[App] Initialized successfully');
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Export for testing
export { registerServiceWorker, handleDeviceRouting, init };
